import pino from 'pino';

import {sendToGroundcover} from './browser/groundcover-transmit';

const logger = pino({
  level: process.env.LOG_LEVEL || `info`,
  messageKey: `message`,
  serializers: {err: pino.stdSerializers.err, error: pino.stdSerializers.err},
  redact: {
    paths: [
      `req.headers.Authorization`,
      `req.headers.authorization`,
      `req.headers.cookie`,
      `req.headers.Authorization`,
      `jwt.accessToken`,
    ],
    censor: `[REDACTED]`,
    remove: true,
  },
  formatters: {
    level: label => ({level: label}),
  },
  browser: {
    asObject: true,
    serialize: true,
    transmit: {
      level: `warn`,
      send: sendToGroundcover,
    },
  },
});

export default logger;
